import React from 'react';
import { HeroBackgroundVideo } from 'assets/landing';
// import { Navbar } from '../navbar';
import Styles from './heroSection.module.scss';

export const HeroSection = () => {
	return (
		<section className={Styles.heroContainer}>
			<video
				className={Styles.video}
				autoPlay
				loop
				muted
				playsInline
			>
				<source src={HeroBackgroundVideo} type="video/mp4" />
				Your browser does not support the video tag.
			</video>
			{/* <div className={Styles.overlay}>
				<Navbar />
			</div> */}
		</section>
	);
};
